import type { FC } from 'react';

import type { IconProps } from '@crehana/icons/types';
import { clsx } from 'clsx';

import type { IconLabelProps } from './types';

const IconLabel: FC<React.PropsWithChildren<IconLabelProps>> = ({
  icon,
  label,
  description,
  textColor,
  isJustified,
  isSection,
  withDivider,
  trailingContent,
  className,
}) => {
  const labelColor = 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100';
  const descriptionColor =
    'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500';

  const RenderSectionIcon = () => {
    const Icon = icon as FC<React.PropsWithChildren<IconProps>>;
    return (
      <div className="tw-flex tw-h-[40px] tw-w-[40px] tw-rounded-0.8 tw-justify-center tw-flex-shrink-0 tw-bg-primary-light-100 dark:tw-bg-neutral-dark-700">
        <Icon
          size={24}
          className="tw-flex tw-self-center tw-flex-shrink-0 tw-text-primary-light-500 dark:tw-text-primary-light-200"
        />
      </div>
    );
  };

  return (
    <div
      className={clsx(
        'tw-flex ',
        isJustified && 'tw-justify-center',
        withDivider &&
          'tw-pb-[20px] tw-mb-[20px] tw-border-solid tw-border-b-[1px] tw-border-b-neutral-light-400 dark:tw-border-b-neutral-dark-700',
        className,
      )}
    >
      {(!isJustified && isSection && <RenderSectionIcon />) ||
        (icon as React.ReactNode)}
      <div
        className={clsx(
          'tw-ml-[8px] tw-pl-[4px] tw-flex tw-flex-col',
          isJustified && 'tw-justify-center',
        )}
      >
        <p className={clsx('tw-font-subtitle4', textColor || labelColor)}>
          {label}
        </p>
        {Boolean(description) && (
          <p
            className={clsx(
              'tw-inline tw-font-body4 tw-whitespace-pre-line',
              textColor || descriptionColor,
            )}
          >
            {description}
          </p>
        )}
      </div>
      {trailingContent}
    </div>
  );
};

export default IconLabel;
